import React, { useEffect } from 'react';
import { u as useInView_2 } from './useInView-CMTI-J0M.js';
import { u as useDataListContext } from './DataListContext-CyU4jeBU.js';
import { f as DATA_LOAD_MORE_TEST_ID, g as DATA_LIST_LOADING_MORE_SPINNER_TEST_ID } from './DataList.const-CjTyAhOC.js';
import { S as Spinner } from './Spinner---cbFcCd.js';
import { B as Button } from './Button-DJQVVE0-.js';

var styles = {"trigger":"IC-Y9bTIVFo-","loadingMore":"PbZLGpbI6ZM-","backToTop":"_6zA6B-jmz6o-","fadeIn":"gZ4DUv82g5I-"};

function DataListLoadMoreTrigger() {
    const { onLoadMore } = useDataListContext();
    const [inViewRef, isInView] = useInView_2();
    useEffect(() => {
        isInView && (onLoadMore === null || onLoadMore === void 0 ? void 0 : onLoadMore());
    }, [isInView]);
    return (React.createElement("div", { ref: inViewRef, className: styles.trigger, "data-testid": DATA_LOAD_MORE_TEST_ID }));
}

const MAX_DATA_COUNT = 50;
function DataListLoadMore({ onBackToTop }) {
    const { loadingState, data } = useDataListContext();
    const showBackToTop = data.length > MAX_DATA_COUNT && loadingState !== "loadingMore";
    return (React.createElement(React.Fragment, null,
        React.createElement(DataListLoadMoreTrigger, { key: data.length }),
        loadingState === "loadingMore" && (React.createElement("div", { "data-testid": DATA_LIST_LOADING_MORE_SPINNER_TEST_ID, className: styles.loadingMore },
            React.createElement(Spinner, { size: "small" }))),
        showBackToTop && (React.createElement("div", { className: styles.backToTop },
            React.createElement(Button, { label: "Back to top", onClick: onBackToTop, size: "small", variation: "subtle" })))));
}

export { DataListLoadMore as D, MAX_DATA_COUNT as M };
